import { jsx as r, Fragment as g } from "react/jsx-runtime";
import o, { startTransition as h } from "react";
import { clsx as c } from "clsx";
const e = {
  aterrizaje: () => async () => import("./aterrizaje-BRKGfi5E.js"),
  despegue: () => async () => import("./despegue-BqmnpJrI.js"),
  ida: () => async () => import("./ida-CAugbNOO.js"),
  "servicio-tarjeta-de-embarque-movil": () => async () => import("./servicio-tarjeta-de-embarque-movil-BOvUKGLK.js"),
  vuelos: () => async () => import("./vuelos-C7z1O0TG.js"),
  vuelta: () => async () => import("./vuelta-lHfs6beq.js"),
  "atencion-telefonica": () => async () => import("./atencion-telefonica-ByjZcYId.js"),
  editar: () => async () => import("./editar-D_XbivMQ.js"),
  "flecha-1-derecha": () => async () => import("./flecha-1-derecha-A2V2scOB.js"),
  "flecha-1-izquierda": () => async () => import("./flecha-1-izquierda-CAvSwriS.js"),
  "flecha-2-derecha": () => async () => import("./flecha-2-derecha-D64zutwB.js"),
  "flecha-2-izquierda": () => async () => import("./flecha-2-izquierda-BMfjQfVk.js"),
  informacion_2: () => async () => import("./informacion_2-DfymXa2r.js"),
  "pago-cuotas": () => async () => import("./pago-cuotas-DxadGvtl.js"),
  "pass-hidden": () => async () => import("./pass-hidden-4Qng3tWB.js"),
  "pass-view": () => async () => import("./pass-view-DgkV-j7s.js"),
  "parking-vip": () => async () => import("./parking-vip-NpoX5Xim.js"),
  "sala-vip": () => async () => import("./sala-vip-gW2pA6fN.js"),
  bebes: () => async () => import("./bebes-CkoE667j.js"),
  ninos: () => async () => import("./ninos-BUCNqm5-.js"),
  perfil: () => async () => import("./perfil-BxPZa_i3.js"),
  "usuario-logado": () => async () => import("./usuario-logado-agTkdPzk.js"),
  "acompanantes-frecuentes": () => async () => import("./acompanantes-frecuentes-DqVjieLz.js"),
  "asiento-delantero": () => async () => import("./asiento-delantero-BOJG6VBR.js"),
  "asiento-plus": () => async () => import("./asiento-plus-q4iflTDl.js"),
  "asiento-upgrade": () => async () => import("./asiento-upgrade-BHAL1L37.js"),
  asiento: () => async () => import("./asiento-92iyhQHV.js"),
  "embarque-prioritario": () => async () => import("./embarque-prioritario-CVpyMDhk.js"),
  "fast-track": () => async () => import("./fast-track-Bb1iWGAu.js"),
  "pasajero-masculino": () => async () => import("./pasajero-masculino-BscUtWbb.js"),
  "pasajeros-2": () => async () => import("./pasajeros-2-D79M3AiU.js"),
  compensacion: () => async () => import("./compensacion-CIw3BcLn.js"),
  elite: () => async () => import("./elite-663UbRgq.js"),
  "favoritos-2": () => async () => import("./favoritos-2-BnmWMCYK.js"),
  filtros: () => async () => import("./filtros-BJW2b6-U.js"),
  "finds-destination": () => async () => import("./finds-destination-0AynDJQ1.js"),
  gestion: () => async () => import("./gestion-Qk5PJICe.js"),
  mensaje: () => async () => import("./mensaje-DW9YgUWk.js"),
  "menu-points": () => async () => import("./menu-points-BUuf3u6r.js"),
  menu: () => async () => import("./menu-BctRWnlP.js"),
  "passbook-tarjeta-embarque": () => async () => import("./passbook-tarjeta-embarque-JOx4qVPT.js"),
  "puente-aereo": () => async () => import("./puente-aereo-fe3cNXcv.js"),
  puente_aereo: () => async () => import("./puente_aereo-fe3cNXcv.js"),
  recargar: () => async () => import("./recargar-DOIScJ8W.js"),
  "reloj-bold": () => async () => import("./reloj-bold-iBMz2oYt.js"),
  reloj: () => async () => import("./reloj-DOtfrnCM.js"),
  "satisfaccion-cliente": () => async () => import("./satisfaccion-cliente-scWFTQIr.js"),
  "servicio-limusina": () => async () => import("./servicio-limusina-UwawiJUY.js"),
  tarjetas: () => async () => import("./tarjetas-Da6JWatI.js"),
  "bandeja-comida": () => async () => import("./bandeja-comida-XAACxXKP.js"),
  "e-carrito": () => async () => import("./e-carrito-BJuVaM2I.js"),
  "idiomas-web": () => async () => import("./idiomas-web-gt7YsLuP.js"),
  regalo: () => async () => import("./regalo-DU0vICuO.js"),
  iberia: () => async () => import("./iberia-C2ZeDDBl.js"),
  "equipaje-10-14kg": () => async () => import("./equipaje-10-14kg-QBF8qsAq.js"),
  "maleta-15kg": () => async () => import("./maleta-15kg-jViyuLkF.js"),
  "e-facturacion-prioritaria": () => async () => import("./e-facturacion-prioritaria-PttIGhkk.js"),
  "e-trolley": () => async () => import("./e-trolley-BuGTtfuX.js"),
  "calendario-reembolso": () => async () => import("./calendario-reembolso-BlzkZx8t.js"),
  calendario: () => async () => import("./calendario-B8ZQcxAk.js"),
  email: () => async () => import("./email-DKcBcN2J.js"),
  "avios-filled": () => async () => import("./avios-filled-BofnyO66.js"),
  "credito-personal-avios": () => async () => import("./credito-personal-Avios-C6EVFRRY.js"),
  "obtencion-avios": () => async () => import("./obtencion-avios-CN1GFL_T.js"),
  "upgrading-avios": () => async () => import("./upgrading-avios-DbntOnUP.js"),
  "utilizacion-avios": () => async () => import("./utilizacion-avios-C8NrvLWp.js"),
  ajustes: () => async () => import("./ajustes-H0NZkYOA.js"),
  alerta: () => async () => import("./alerta-DfeyBRYI.js"),
  alertas: () => async () => import("./alertas-CQsY7P0h.js"),
  "ayuda-2": () => async () => import("./ayuda-2-Bo1M3Z3F.js"),
  ayuda: () => async () => import("./ayuda-DKGr2GJq.js"),
  buscar: () => async () => import("./buscar-CUC7Rlga.js"),
  "caret-abajo": () => async () => import("./caret-abajo-BbK3VsIs.js"),
  "caret-arriba": () => async () => import("./caret-arriba-D6yfJ6Nv.js"),
  "caret-derecha": () => async () => import("./caret-derecha-DdGX7cJe.js"),
  "caret-izquierda": () => async () => import("./caret-izquierda-D83YKwyZ.js"),
  "chevron-line-down": () => async () => import("./chevron-line-down-Br-8jdZ8.js"),
  "chevron-line-up": () => async () => import("./chevron-line-up-DEymYfNy.js"),
  close: () => async () => import("./close-DHYVKN_9.js"),
  "compartir-2": () => async () => import("./compartir-2-GnOekvfb.js"),
  compartir: () => async () => import("./compartir-Dpy7jfc2.js"),
  confirmacion: () => async () => import("./confirmacion-Ca6O9Dm4.js"),
  encendido: () => async () => import("./encendido-Bg9vdUqP.js"),
  "enlazar-bc": () => async () => import("./enlazar-BC-BbyOb7it.js"),
  info: () => async () => import("./info-CMTp1lxZ.js"),
  mas: () => async () => import("./mas-BBstWzqr.js"),
  "mejor-precio": () => async () => import("./mejor-precio-DDmf-E4m.js"),
  "no-disponible": () => async () => import("./no-disponible-CtNAY6jC.js"),
  papelera: () => async () => import("./papelera-CZTTrcpk.js"),
  "senalizacion-mapas": () => async () => import("./senalizacion-mapas-qWZC6PP5.js"),
  transferencia: () => async () => import("./transferencia-Bj_EyZof.js"),
  validar: () => async () => import("./validar-JfLYZSXW.js"),
  sostenibilidad: () => async () => import("./sostenibilidad-CEjIpMIp.js")
};
function b(a) {
  const i = a / 16;
  return `${String(i)}rem`;
}
function v(a) {
  if (a === "full" || !a)
    return { width: "100%", height: "100%" };
  const i = b(a);
  return { width: i, height: i };
}
const p = o.forwardRef(
  ({ name: a, size: i, description: n, color: m = "currentColor", className: t, ...y }, l) => {
    const { width: d, height: u } = v(i), f = o.useMemo(() => o.lazy(e[a]()), [a]);
    let s = null;
    return h(() => {
      s = /* @__PURE__ */ r(
        f,
        {
          "data-name": a,
          ref: l,
          fill: m,
          width: d,
          height: u,
          desc: n,
          className: c(t),
          ...y
        }
      );
    }), /* @__PURE__ */ r(o.Suspense, { fallback: /* @__PURE__ */ r("div", { className: c(t) }), children: s });
  }
);
p.displayName = "IconDigitalMemo";
const j = o.forwardRef(({ name: a, ...i }, n) => e[a] ? /* @__PURE__ */ r(p, { ...i, name: a, ref: n }) : /* @__PURE__ */ r(g, {}));
j.displayName = "IconDigital";
export {
  j as I
};
